import { render, staticRenderFns } from "./Availables.vue?vue&type=template&id=55b2cf67&"
import script from "./Availables.vue?vue&type=script&lang=js&"
export * from "./Availables.vue?vue&type=script&lang=js&"
import style0 from "./Availables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Availables.vue"
export default component.exports